import router from './router'
import store from './store'
import { Toast } from 'vant'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/util/auth' // get token from cookie

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/'] // no redirect whitelist
let latestNavigation = null

router.beforeEach(async (to, from, next) => {
  latestNavigation = to
  // start progress bar
  NProgress.start()
  // set page title
  document.title = to.meta.title

  const hasToken = getToken()


  const { userid, ewm_catId } = to.query
  if (userid) {
    sessionStorage.setItem("agentUserId", userid)
    if (ewm_catId) {
      localStorage.setItem("ewm_catId", ewm_catId)
    } else {
      localStorage.removeItem("ewm_catId")
    }
  } else if (ewm_catId) {
    localStorage.setItem("ewm_catId", ewm_catId)
  }

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo

      if (Object.keys(store.getters.userInfo).length) {
        if (to.meta.hasAuth && store.getters.userInfo.id && !store.getters.userInfo.phone) {
          let mustBindPhone = true
          try {
            mustBindPhone = await store.dispatch('user/loadPhoneBindingSetting')
          } catch (error) {
            if (latestNavigation === to && getToken() === hasToken) Toast('手机号绑定设置加载失败，请稍后重试')
          }
          if (latestNavigation !== to || getToken() !== hasToken) {
            next(false)
            if (latestNavigation === to) NProgress.done()
            return
          }
          if (mustBindPhone) {
            next({ path: '/bindphone', query: { ...to.query, redirect: to.path }, replace: true })
            NProgress.done()
            return
          }
        }
        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          await store.dispatch('user/getInfo')
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Toast(error || 'Has Error')
          next({ path: '/login', params: from.query })
          NProgress.done()
        }
      }
    }
  } else {

    if (!to.meta.hasAuth) {
      next()
    } else {
      console.log(to, from);
      next({ path: '/login', query: from.query })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js